import { Controller } from '@hotwired/stimulus'
import { MediaEmbed } from '../../api/models/types'
import { getComponentContext, lifecycleTrigger } from '../../helpers/controllerHelpers/utils'
import replaceStorageURLsFromFirebaseToCloudflare from '../../api/helpers/replaceStorageURLsFromFirebaseToCloudflare'

export default class extends Controller {
  static classes = ['clickable', 'video']
  static targets = ['video-placeholder', 'play-button']
  static values = { src: String, autoplay: Boolean }

  activated: boolean
  declare hasVideoPlaceholderTarget: boolean
  declare videoPlaceholderTarget: HTMLElement
  declare hasVideoClass: boolean
  declare autoplayValue: boolean
  declare srcValue: string
  declare hasPlayButtonTarget: boolean
  declare playButtonTarget: HTMLElement
  declare videoClass: string
  component: MediaEmbed
  flowEl: Element | null

  connect() {
    this.activated = false
    const { component, flowEl } = getComponentContext(this)
    this.component = component as MediaEmbed
    this.flowEl = flowEl
    lifecycleTrigger(this, 'mounted')
  }

  disconnect() {
    lifecycleTrigger(this, 'unmounted')
  }

  activatePlayer() {
    this.activated = true
    if (this.hasVideoPlaceholderTarget) {
      const parent = this.videoPlaceholderTarget.parentElement
      this.videoPlaceholderTarget.remove()
      const videoEl = document.createElement('video')
      if (this.hasVideoClass) videoEl.classList.add(this.videoClass)
      videoEl.autoplay = this.autoplayValue
      videoEl.controls = true
      videoEl.src = replaceStorageURLsFromFirebaseToCloudflare(this.srcValue) || ''
      parent?.appendChild(videoEl)
    }
    if (this.hasPlayButtonTarget) this.playButtonTarget.remove()
  }
}
